import { Box } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { getProducts } from "../../../actions/products";
import { imageUrl, sortFn } from "../../../helpers/common";
import CategoryCard from "../../Common/CategoryCard";

function FeaturedProductCarousel({ productId }) {
  const dispatch = useDispatch();
  const { currentPage } = useParams();
  const [page, setpage] = useState(1);
  const featuredProducts = useSelector(
    (state) => state.products[productId ? "similar" : "featured"]
  );

  useEffect(() => {
    dispatch(getProducts({ product_labels: productId }, 10, 1));
  }, [dispatch, productId]);

  useEffect(() => {
    setpage(parseInt(currentPage, 10));
  }, [currentPage]);

  const responsive = {
    largeScreen: {
      breakpoint: { max: 4000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 1,
    },
  };

  const windowScroll = () => {
    window.scrollTo({
      top: 200,
      behavior: "smooth",
    });
  };

  return (
    <Box overflow='hidden' maxWidth={1120} margin='auto'>
      <Carousel
        draggable={true}
        keyBoardControl={true}
        responsive={responsive}
        infinite={true}
        partialVisible={"false"}
        autoPlay
        autoPlaySpeed={3000}
        arrows={false}
        showDots
      >
        {featuredProducts.sort(sortFn).map((product) => (
          <Box
            key={product.id}
            onClick={windowScroll}
            display='flex'
            justifyContent='center'
            mb={5}
          >
            <Link
              to={`/product/${product.id}/${parseInt(page, 10)}/${
                product.url_slug
              }`}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <CategoryCard
                image={imageUrl(
                  product.main_image,
                  "products/" + product.id,
                  "600x600-"
                )}
                title={product.name}
                width={300}
                square
              />
            </Link>
          </Box>
        ))}
      </Carousel>
    </Box>
  );
}

export default FeaturedProductCarousel;
